import { theme, TimeLabel } from '@mi-front/ui';
import { alpha, Box } from '@mui/material';
import { useTimezone } from '../../../../../../core/hooks';
import { PREVIEW_HEIGHT } from './config';

interface Props {
  readonly ts: number;
}

/**
 * Preview-specific hover label rendered by TimeBrush while hovering outside selection.
 */
export function PreviewBrushHoverLabel({ ts }: Props) {
  const tz = useTimezone();

  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative' }}
    >
      <Box
        sx={{
          width: '2px',
          height: PREVIEW_HEIGHT,
          backgroundColor: alpha(theme.green, 0.8),
          position: 'absolute',
          top: 0,
        }}
      />
      <TimeLabel
        ts={ts}
        tz={tz}
        size="sm"
        style={{ backgroundColor: '#333', marginTop: 4, position: 'absolute', top: 0 }}
      />
    </Box>
  );
}
